/**
 * Cascading (Masonry) grid layout
 * 
 * @requires https://github.com/desandro/imagesloaded
 * @requires https://github.com/Vestride/Shuffle
 */

const masonryGrid = (() => {

    if ('undefined' === typeof Shuffle) {
        console.info('Shuffle is not loaded!');
        return;
    }
    if ('undefined' === typeof imagesLoaded) {
        console.info('imagesLoaded is not loaded!');
        return;
    }

    let grid = document.querySelectorAll('.masonry-grid'),
            masonry;

    if (grid === null) {
        return;
    }

    //for (let element of grid) {
    for (let i = 0; i < grid.length; i++) {
        let element = grid[i];
        masonry = new Shuffle(element, {
            itemSelector: '.masonry-grid-item',
            sizer: '.masonry-grid-item'
        });
        imagesLoaded(element).on('progress', () => {
            masonry.layout();
        });
    }
})();

export default masonryGrid;
